/* global YT */
/* eslint-disable no-unused-vars */
/* eslint no-param-reassign: "error" */
/* eslint-disable no-new */

// *******************************************************************************
// 0.0 - BREAKPOINT VARS
// *******************************************************************************
const breakpointSm = 767;
const breakpointMd = 1023;
const breakpointLg = 1171;

// *******************************************************************************
// 0.1 - VARIOUS FUNCTIONS
// *******************************************************************************

// Return Window Width
function windowWidth() {
  return window.innerWidth || document.documentElement.clientWidth;
}

// *******************************************************************************
// 0.2 - FUNCTIONS
// *******************************************************************************

// Attach Events
function attachEvent(selector, event, handler) {
  document.addEventListener(
    event,
    (ev) => {
      let { target } = ev;
      for (; target && target !== document; target = target.parentNode) {
        if (target.matches(selector)) {
          try {
            handler.call(target, ev);
          } catch (e) {
            console.error(e);
          }
          break;
        }
      }
    },
    false,
  );
}

// Animate
function animate(elementToAnimate, type) {
  switch (type) {
    case 'show':
      elementToAnimate.classList.add('is-visible');
      elementToAnimate.classList.remove('is-hidden');
      break;
    case 'hide':
      elementToAnimate.classList.add('is-hidden');
      elementToAnimate.classList.remove('is-visible');
      break;
    default:
      break;
  }
}
// Validate email input
function validateEmailInput(email) {
  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}

// *******************************************************************************
// 0.3 - DEBOUNCE FUNCTION
// *******************************************************************************

function debounce(func, wait, immediate) {
  let timeout;
  return function (...args) {
    const context = this;
    const later = function () {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    const callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}

// *******************************************************************************
// 0.4 - RESPONSIVE BG IMAGES
// *******************************************************************************

class ResponsiveBackgroundImage {
  constructor(element) {
    this.element = element;
    this.img = element.querySelector('img');
    this.src = '';

    this.img.addEventListener('load', () => {
      this.update();
    });

    if (this.img.complete) {
      this.update();
    }
  }

  update() {
    const src = typeof this.img.currentSrc !== 'undefined' ? this.img.currentSrc : this.img.src;
    if (this.src !== src) {
      this.src = src;
      this.element.style.backgroundImage = `url("${this.src}")`;
    }
  }
}

const elements = document.querySelectorAll('[data-responsive="responsive-bg-image"]');

function responsiveBgImagesLoop() {
  for (let i = 0; i < elements.length; i += 1) {
    new ResponsiveBackgroundImage(elements[i]);
  }
}

responsiveBgImagesLoop();

// *******************************************************************************
// 0.5 - SLIDE FUNCTIONS
// *******************************************************************************

const slideUp = (target, duration) => {
  target.style.transitionProperty = 'height, margin, padding';
  target.style.transitionDuration = `${duration}ms`;
  target.style.boxSizing = 'border-box';
  target.style.height = `${target.offsetHeight}px`;
  // eslint-disable-next-line no-unused-expressions
  target.offsetHeight;
  target.style.overflow = 'hidden';
  target.style.height = 0;
  target.style.paddingTop = 0;
  target.style.paddingBottom = 0;
  target.style.marginTop = 0;
  target.style.marginBottom = 0;
  window.setTimeout(() => {
    target.style.display = 'none';
    target.style.removeProperty('height');
    target.style.removeProperty('padding-top');
    target.style.removeProperty('padding-bottom');
    target.style.removeProperty('margin-top');
    target.style.removeProperty('margin-bottom');
    target.style.removeProperty('overflow');
    target.style.removeProperty('transition-duration');
    target.style.removeProperty('transition-property');
  }, duration);
};

const slideDown = (target, duration, displayType) => {
  target.style.removeProperty('display');

  let { display } = window.getComputedStyle(target);

  // eslint-disable-next-line no-unused-expressions
  display === 'none' ? (display = displayType) : null;
  target.style.display = display;

  target.style.display = display;
  const height = target.offsetHeight;
  target.style.overflow = 'hidden';
  target.style.height = 0;
  target.style.paddingTop = 0;
  target.style.paddingBottom = 0;
  target.style.marginTop = 0;
  target.style.marginBottom = 0;
  // eslint-disable-next-line no-unused-expressions
  target.offsetHeight;
  target.style.boxSizing = 'border-box';
  target.style.transitionProperty = 'height, margin, padding';
  target.style.transitionDuration = `${duration}ms`;
  target.style.height = `${height}px`;
  target.style.removeProperty('padding-top');
  target.style.removeProperty('padding-bottom');
  target.style.removeProperty('margin-top');
  target.style.removeProperty('margin-bottom');
  window.setTimeout(() => {
    target.style.removeProperty('height');
    target.style.removeProperty('overflow');
    target.style.removeProperty('transition-duration');
    target.style.removeProperty('transition-property');
  }, duration);
};

const slideToggle = (target, duration, displayType) => {
  /* Slide-toggle logic */

  if (window.getComputedStyle(target).display === 'none') {
    return slideDown(target, duration, displayType);
    // eslint-disable-next-line no-else-return
  } else {
    return slideUp(target, duration, displayType);
  }
};

function calcVh() {
  const vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
}
calcVh();
const debounceCalcVh = debounce(() => {
  calcVh();
}, 100);

window.addEventListener('resize', () => {
  debounceCalcVh();
});

// *******************************************************************************
// 0.6 - Play video
// *******************************************************************************

function VideoPlayer(parentElem) {
  let player;
  const idString = 'id_';
  const number = Math.floor(Math.random() * 10000 + 1);
  const videoID = idString.concat('', number);
  const parent = parentElem.querySelector('[data-video]');
  const videoURL = parentElem.querySelector('[data-video-poster]').getAttribute('data-id');

  // Add class to parent for hiding poster
  parent.classList.add('is-playing');

  // Set the div ID to match API player ID
  parent.querySelector('[data-video-container]').id = videoID;

  // API EVENT: Play
  function onPlayerReady(event) {
    event.target.playVideo();
  }

  // API EVENT: Check for ending
  function onPlayerStateChange(event) {
    if (event.data === 0) {
      // Stop and destroy player (stops video and removes player instance and iframe)
      parent.classList.remove('is-playing');
      player.stopVideo();
      player.destroy();
      player = null;
    }
  }

  // API: Create new player
  player = new YT.Player(videoID, {
    // Set the api ID to match div ID
    videoId: videoURL,
    playerVars: {
      modestbranding: 1,
      rel: 0,
      showinfo: 0,
      color: 'white',
    },
    events: {
      onReady: onPlayerReady,
      onStateChange: onPlayerStateChange,
    },
  });
}

function resetVideoPlayer(parentElem) {
  const modalVideoIframe = parentElem.querySelector('.video__iframe-container');
  const videoElem = parentElem.querySelector('[data-video]');
  const modalVideoIframeParent = parentElem.querySelector('.video__iframe');

  if (typeof modalVideoIframe !== 'undefined' && modalVideoIframe != null) {
    modalVideoIframe.remove();
    modalVideoIframeParent.innerHTML = "<div class='video__iframe-container' data-video-container></div>";
    videoElem.classList.remove('is-playing');
  }
}

// *******************************************************************************
// Smooth Scroll
// *******************************************************************************

function clickHandler(offsetTop) {
  // eslint-disable-next-line no-restricted-globals
  scroll({
    top: offsetTop,
    behavior: 'smooth',
  });
}
